(function () {
  if (window.initStampedReviews) return;

  const DEFAULT_SCOPE_SELECTOR = 'body';
  const DEFAULT_TARGET_SELECTOR = '.raiting';
  const DEFAULT_RATING_SELECTOR = '.stamped-summary-text';

  const fullStar = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" width="16" height="16">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.91614 1.65777C8.6377 0.780747 7.3623 0.780737 7.08386 1.65777L5.87791 5.45633H1.96075C1.04355 5.45633 0.649794 6.58938 1.37865 7.13134L4.58841 9.51804L3.36566 13.3695C3.09002 14.2377 4.12202 14.9384 4.8639 14.3867L8 12.0548L11.1361 14.3867C11.878 14.9384 12.91 14.2377 12.6343 13.3695L11.4116 9.51804L14.6213 7.13134C15.3502 6.58938 14.9564 5.45633 14.0392 5.45633H10.1221L8.91614 1.65777Z" fill="#FF8C27"/>
</svg>`;

  const emptyStar = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" width="16" height="16">
  <path d="M7.6998 2.02065C7.82047 1.76916 8.17953 1.76916 8.3002 2.02065L10.0126 5.59025C10.0612 5.69149 10.1578 5.76139 10.2694 5.77603L14.2103 6.29274C14.488 6.32916 14.5991 6.67057 14.3957 6.86262L11.5139 9.5837C11.4319 9.66103 11.3949 9.7745 11.4155 9.88517L12.1391 13.7722C12.1902 14.0465 11.8996 14.2574 11.6535 14.1246L8.1584 12.2377C8.0596 12.1844 7.9404 12.1844 7.8416 12.2377L4.34646 14.1246C4.10042 14.2574 3.80982 14.0465 3.86088 13.7722L4.5845 9.88517C4.60509 9.7745 4.56807 9.66103 4.48613 9.5837L1.60434 6.86262C1.40095 6.67057 1.51202 6.32916 1.78975 6.29274L5.7306 5.77603C5.8422 5.76139 5.93882 5.69149 5.98739 5.59025L7.6998 2.02065Z" stroke="#FF8C27" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

  function starHTML(fillPercent) {
    return `
    <span class='tw-relative tw-inline-block tw-w-[16px] tw-h-[16px]'>
      ${emptyStar}
      <span class='tw-absolute tw-top-0 tw-left-0 tw-h-full tw-overflow-hidden' style='width:${fillPercent}%;'>
        ${fullStar}
      </span>
    </span>
  `;
  }

  function starsFromRating(rating) {
    const displayRating = Math.min(5, Math.max(0, rating));
    return [...Array(5).keys()]
      .map(i => {
        const fillPercent = Math.min(1, Math.max(0, displayRating - i)) * 100;
        return starHTML(fillPercent);
      })
      .join('');
  }

  function renderReviews({ ratingSelector, scopeSelector, targetSelector }) {
    const ratingEl = document.querySelector(ratingSelector);
    if (!ratingEl) return false;

    const scope =
      scopeSelector && scopeSelector !== 'body'
        ? document.querySelector(scopeSelector)
        : document;
    if (!scope) return false;

    const targets = scope.querySelectorAll(targetSelector);
    if (!targets.length) return false;

    const score = Array.from(targets).some(el =>
      el.classList.contains('raiting-score')
    );

    const rating = parseFloat(ratingEl.dataset.rating);
    const count = parseInt(ratingEl.dataset.count, 10);
    if (Number.isNaN(rating) || Number.isNaN(count)) return false;

    const starsHTML = starsFromRating(rating);
    const singleLabel = window.textReview || 'Review';
    const pluralLabel = window.textReviews || 'Reviews';
    const markup = `
      <a href='#' class='raiting__btn'>
        <div class='tw-flex tw-items-center tw-gap-2x'>
          <div class='tw-flex tw-items-center tw-relative' style='gap:2px'>${starsHTML}</div>
          <p class='tw-text-[14px] tw-leading-[100%] tw-tracking-[-0.01em] stamped-reviews-text' style='text-decoration: underline; text-underline-position: from-font;'>
            ${score ? rating : count === 1 ? `${count} ${singleLabel}` : `${count} ${pluralLabel}`}
          </p>
        </div>
      </a>
    `;

    rating === 0
      ? targets.forEach(target => {
          target.classList.add('!tw-hidden');
        })
      : targets.forEach(target => {
          target.innerHTML = markup;
        });

    return true;
  }

  window.initStampedReviews = function (options = {}) {
    const settings = {
      scopeSelector: options.scopeSelector || DEFAULT_SCOPE_SELECTOR,
      targetSelector: options.targetSelector || DEFAULT_TARGET_SELECTOR,
      ratingSelector: options.ratingSelector || DEFAULT_RATING_SELECTOR
    };

    if (renderReviews(settings)) return;

    const observer = new MutationObserver(() => {
      if (renderReviews(settings)) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('click', function (e) {
    const link = e.target.closest('.raiting__btn');
    if (!link) return;

    e.preventDefault();

    const target = document.querySelector('#stamped-main-widget');
    if (!target) return;
    const target_wrapper = target.closest('.stamped');

    const baseOffset = window.innerWidth >= 1024 ? 120 : 44;
    let headerOffset = baseOffset;
    if (target_wrapper) {
      const computedStyle = window.getComputedStyle(target_wrapper);
      const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
      headerOffset = baseOffset + paddingTop;
    }

    const offsetTop =
      target.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    });
  });
})();
